import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useSkipBillModalStyles = makeStyles({
  emptyForm: {
    padding: '16px 24px 24px 24px'
  },
  emptyFormList: {
    marginTop: '12px'
  },
  emptyFormListTitle: {
    marginBottom: '10px',
    '& .MuiTypography-root': {
      color: palette.shades[700]
    }
  },
  emptyFormListItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiTypography-root': {
      fontSize: '18px',
      paddingRight: '8px'
    },
    '&:not(:first-child)': {
      marginTop: '8px'
    }
  },
  emptyFormTextArea: {
    marginTop: '24px',
    '& textarea': {
      width: '100%',
      resize: 'none',
      padding: '12px',
      outline: 'none',
      maxWidth: '100%',
      minWidth: '100%',
      fontSize: '18px',
      lineHeight: '24px',
      borderRadius: '2px',
      border: '1px solid #B8C4CE',
      fontFamily: palette.fontFamilies.source
    }
  }
});
export default useSkipBillModalStyles;